import React from "react";
import { Routes, Route, NavLink, useParams, useNavigate, useLocation} from "react-router-dom";
import { Tabs, Tab, Box, Typography } from "@mui/material";

import { SxProps, Theme } from "@mui/system";
import GeneralSettings from "./general";
import FieldSettingsTable from "./field-settings";
import ApiMethodEditor from "./api-method";
import UIPropertiesEditor from "./ui_properties_editor";

type TabConfig = {
  label: string;
  value: string;
  path: string;
};

const tabConfig: TabConfig[] = [
  { label: "General", value: "general", path: "general" },
  { label: "Field Settings", value: "fields", path: "fields" },
  { label: "API Methods", value: "api_methods", path: "api_methods" },
  { label: "API Properties", value: "api_properties", path: "api_properties" },
  { label: "UI Properties", value: "ui_properties", path: "ui_properties" },
];

const commonTabStyle: SxProps<Theme> = {
  fontSize: "14px",
  textTransform: "none",
  padding: "12px 16px",
  justifyContent: "flex-start",
  "&.Mui-selected": {
    fontWeight: "bold",
    color: "#007aff",
  },
};

const EditFieldSettingDetails: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const location = useLocation(); // This hook returns the current location object

  // Function to derive current tab from URL
  const getCurrentTab = (): string => {
    const match = location.pathname.match(/\/admin\/field-settings\/edit\/\w+\/(\w+)/);
    return match ? match[1] : "general";
  };

  return (
    <Box
      sx={{
        display: "flex",
        backgroundColor: "#FFFFFF",
        borderRadius: "8px",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        overflow: "hidden",
      }}
    >
      <Tabs
        orientation="vertical"
        value={getCurrentTab()}
        indicatorColor="primary"
        textColor="primary"
        sx={{
          width: "200px",
          backgroundColor: "#F5F5F7",
          padding: "8px 0",
          height: "auto",
          borderRight: "1px solid #e0e0e0",
        }}
      >
        {tabConfig.map((tab) => (
          <Tab
            key={tab.value}
            label={tab.label}
            value={tab.path}
            component={NavLink}
            to={`/admin/field-settings/edit/${id}/${tab.path}`}
            sx={commonTabStyle}
          />
        ))}
      </Tabs>
      <Box sx={{ flexGrow: 1, padding: "24px" }}>
        <Routes>
          <Route index element={<GeneralSettings />} />
          <Route path="general" element={<GeneralSettings />} />
          <Route path="fields" element={<FieldSettingsTable />} />
          <Route path="api_methods" element={<ApiMethodEditor />} />
          <Route path="ui_properties" element={<UIPropertiesEditor />} />
        </Routes>
      </Box>
    </Box>
  );
};

export default EditFieldSettingDetails;
